module.exports = __webpack_public_path__ + "static/media/arrow-to-right.839a8e71.svg";